module.exports = __webpack_public_path__ + "static/media/close.d0c96472.svg";